const WHATSAPP_NUMBER = "5437648689046";
const DEFAULT_MESSAGE = "Hola, Coressen quiero hablar con un consultor.";

export const getWhatsAppLink = (message: string = DEFAULT_MESSAGE): string => {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
};

export const WHATSAPP_URL = getWhatsAppLink();
